import { useEffect } from "react";

/**
 * Sets document.title and meta description for the current route.
 * Lets Google's renderer pick up unique per-page SEO without adding any deps.
 * Restores defaults from index.html on unmount so navigation back to "/" is clean.
 */
const DEFAULT_TITLE = "IncentTax | Cost Segregation & R&D Tax Credit Specialists";
const DEFAULT_DESCRIPTION =
  "Incent Tax helps property owners, real estate investors, and businesses maximize tax savings through cost segregation studies and R&D tax credit studies. Schedule a free consultation today.";

function setMeta(name, attr, content) {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function useSEO({ title, description, canonical }) {
  useEffect(() => {
    const fullTitle = title || DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;

    document.title = fullTitle;
    setMeta("description", "name", desc);
    setMeta("og:title", "property", fullTitle);
    setMeta("og:description", "property", desc);
    setMeta("twitter:title", "name", fullTitle);
    setMeta("twitter:description", "name", desc);

    if (canonical) {
      setMeta("og:url", "property", canonical);
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);
}
